module.exports = __webpack_public_path__ + "static/img/Skateboard-2.20f10ee4.png";